import {Action} from 'redux'
import {OptionModel} from '../Model'
import {CollegeDetailModel} from '../Model/CollegeDetailModel'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialCollegeDetailState: ICollegeDetailState = {
  data: {
    aboutCollege: [],
    meta: [],
  },
  aboutTypeOption: [],
  sortCollegeDetailData: [],
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface ICollegeDetailState {
  data?: {
    aboutCollege?: CollegeDetailModel[]
    meta?: {[key: string]: string | number}[]
  }
  aboutTypeOption?: OptionModel[]
  sortCollegeDetailData?: ICollegeDetailState[]
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ICollegeDetailState = initialCollegeDetailState,
  action: ActionWithPayload<ICollegeDetailState>
) => {
  switch (action.type) {
    //GET CollegeDetail DATA
    case actionTypes.GET_COLLEGE_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_COLLEGE_DETAIL_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_COLLEGE_DETAIL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add CollegeDetail
    case actionTypes.ADD_COLLEGE_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_COLLEGE_DETAIL_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_COLLEGE_DETAIL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_COLLEGE_DETAIL: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update CollegeDetail
    case actionTypes.UPDATE_COLLEGE_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_COLLEGE_DETAIL_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_COLLEGE_DETAIL_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_COLLEGE_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_COLLEGE_DETAIL_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_COLLEGE_DETAIL_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_COLLEGE_DETAIL_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_COLLEGE_DETAIL_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_COLLEGE_DETAIL_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_COLLEGE_DETAIL_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_COLLEGE_DETAIL_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_COLLEGE_DETAIL_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_COLLEGE_DETAIL_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_COLLEGE_DETAIL_SUCCESS: {
      const changedData: any = action.payload?.data?.aboutCollege
      let newData = state?.data?.aboutCollege?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, aboutCollege: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_COLLEGE_DETAIL_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_COLLEGE_DETAIL_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_COLLEGE_DETAIL_SUCCESS: {
      const changedData: any = action.payload?.data?.aboutCollege
      let newData = state?.data?.aboutCollege?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, aboutCollege: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_COLLEGE_DETAIL_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_COLLEGE_DETAIL_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_COLLEGE_DETAIL_SUCCESS: {
      return {
        ...state,
        sortCollegeDetailData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_COLLEGE_DETAIL_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_COLLEGE_DETAIL_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortCollegeDetailData: [],
      }
    }

    //Get About Option Reducer
    case actionTypes.GET_ABOUT_TYPE_OPTION_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ABOUT_TYPE_OPTION_SUCCESS: {
      return {
        ...state,
        aboutTypeOption: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_ABOUT_TYPE_OPTION_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    default:
      return state
  }
}
